module.exports = __webpack_public_path__ + "static/img/NSW-1.e5bfee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-1.jpg
// module id = Juns
// module chunks = 0